import Dialog from "cerulean/src/Dialog";
import { Button, Row, Checkbox } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { useState } from "react";

export type BulkApprovalDialog = {
  isOpen: boolean;
  handleClose: () => void;
  handleApprove: () => void;
};

export const BULK_APPROVAL_DIALOG_STORAGE_KEY =
  "hide-dual-approval-bulk-dialog";

const BulkApprovalDialog = ({
  isOpen,
  handleClose,
  handleApprove,
}: BulkApprovalDialog) => {
  const { l10n } = useLocalization();
  const [doNotShow, setDoNotShow] = useState(false);
  const hideDoNotShowAgainCta = Boolean(
    window.localStorage.getItem(BULK_APPROVAL_DIALOG_STORAGE_KEY)
  );

  const handleToggleDoNotShowDialogAgain = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const doNotShowDialogAgain = e.target.checked;
    if (doNotShowDialogAgain) {
      setDoNotShow(true);
    } else {
      setDoNotShow(false);
    }
  };

  const handleClickApprove = () => {
    if (doNotShow && window.localStorage) {
      window.localStorage.setItem(BULK_APPROVAL_DIALOG_STORAGE_KEY, "true");
    }
    handleApprove();
    handleClose();
  };

  return (
    <Dialog
      width="385px"
      isOpen={isOpen}
      onUserDismiss={handleClose}
      title={l10n.getString("approve-bulk-dialog-title")}
      footer={
        <Row alignItems="center">
          <Row.Item>
            <Button
              kind="plain"
              onClick={handleClose}
              testId="cancel-bulk-approval"
            >
              {l10n.getString("button-cancel")}
            </Button>
          </Row.Item>
          <Row.Item shrink>
            <Button onClick={handleClickApprove} testId="confirm-bulk-approval">
              {l10n.getString("approve-modal-confirm")}
            </Button>
          </Row.Item>
        </Row>
      }
    >
      <span className="margin--bottom--xl">
        {l10n.getString("approve-bulk-dialog-content")}
        <div className="margin--top--xl margin--bottom--l">
          {!hideDoNotShowAgainCta ? (
            <Checkbox
              name="bulkModal"
              label={l10n.getString("recurring-modal-cta")}
              onChange={handleToggleDoNotShowDialogAgain}
            />
          ) : null}
        </div>
      </span>
    </Dialog>
  );
};

export default BulkApprovalDialog;
